import TwitterIcon from './TwitterIcon';

export default TwitterIcon;
